// Simple River mesh

import { useStore } from '../../store/useStore';

export const River = () => {
    const theme = useStore((state) => state.theme);
    const isCyberpunk = theme === 'cyberpunk';

    // Cyberpunk River: Neon Pink/Purple stream
    // Medieval: Blue water

    return (
        <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -4, 0]} receiveShadow>
            <planeGeometry args={[300, 300]} />
            <meshStandardMaterial
                color={isCyberpunk ? "#ff00ff" : "#00aaff"}
                transparent
                opacity={isCyberpunk ? 0.8 : 0.6}
                roughness={0.1}
                metalness={isCyberpunk ? 0.8 : 0.1}
                emissive={isCyberpunk ? "#aa00aa" : "black"}
                emissiveIntensity={isCyberpunk ? 1 : 0}
            />
        </mesh>
    );
};
